<script setup lang="tsx">
import { formatDate } from '@/services/utils'
import type { RiskOverviewDeadlines } from '@/models/api-generated'
import CardRow from './CardRow.vue'
import { truncate } from '@/services/utils'

const model = defineModel<RiskOverviewDeadlines>({ required: true })
const today = new Date()

const emit = defineEmits<{
	(e: 'go-to-risks', riskNames: string[], treatments: string[]): void
}>()

function goToRisks(name: string) {
	if (!name) return
	emit('go-to-risks', [name], [])
}
</script>

<template>
	<div class="rounded-container p-4 overflow-auto text-nowrap">
		<p class="text-center fw-bold">
			{{ $t('risk.overview.approaching') }}
		</p>

		<table class="w-100">
			<CardRow :underline="true">
				<template #col0>
					<b>{{ $t('date.overdue') }}</b>
				</template>
				<template #col1></template>
				<template #col_end>
					<span class="orange">{{ model.overDeadline }}</span>
				</template>
			</CardRow>

			<CardRow v-for="a in model.deadlines" :key="a.name">
				<template #col0>
					<span class="badge bg-primary me-2 fixed-badge" v-one-tooltip="a.assetName ? a.assetName : $t('risk.default')">
						{{ a.assetId ? a.assetName : $t('risk.default') }}
					</span>
					<span v-one-tooltip="a.name" @click="goToRisks(a.name)" class="risks-cell">{{ truncate(a.name, 30) }}</span>
				</template>
				<template #col1></template>
				<template #col_end>
					<span :class="[a.date && new Date(a.date) < today ? 'red' : '']">
						{{ formatDate(a.date) }}
					</span>
				</template>
			</CardRow>

			<CardRow :underline="true">
				<template #col0>
					<b>{{ $t('risk.overview.lastReview') }}</b>
				</template>
				<template #col1></template>
				<template #col_end>
					<span class="orange">{{ model.yearOverReview }}</span>
				</template>
			</CardRow>

			<CardRow v-for="a in model.lastReviewed" :key="a.name">
				<template #col0>
					<span class="badge bg-primary me-2 fixed-badge" v-one-tooltip="a.assetName ? a.assetName : $t('risk.default')">
						{{ a.assetId ? a.assetName : $t('risk.default') }}
					</span>
					<span v-one-tooltip="a.name" @click="goToRisks(a.name)" class="risks-cell">{{ truncate(a.name, 30) }}</span>
				</template>
				<template #col1></template>
				<template #col_end>
					<span :class="[a.days > 365 ? 'red' : '']">
						{{ a.days }}
					</span>
				</template>
			</CardRow>
		</table>
	</div>
</template>
